import {
  PAYROLL_ALL,
  PAYROLL_GET,
  PAYROLL_PUT,
  PAYROLL_DELETE,
  PAYROLL_POST,
  PAYROLL_LOADING,
  PAYROLL_ERROR,
} from '../../actions/types';

const initialState = {
  PAYROLL: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function PayrollReducer(state = initialState, action) {
  switch (action.type) {
    case PAYROLL_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYROLL_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYROLL_POST:
      return { isLoading: false, isCompleted: true };
    case PAYROLL_PUT:
      return { isLoading: false, isCompleted: true };
    case PAYROLL_DELETE:
      return { isLoading: false, isCompleted: true };
    case PAYROLL_LOADING:
      return { isLoading: true, isCompleted: true };
    case PAYROLL_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
